import DriveSidebar from 'components/layout/DriveSidebar'
import { useEffect, useState } from 'react'
import Helmet from 'react-helmet'
import Page from 'rui/widgets/Page'
import CaseStatus from '../CaseStatus'
import { getSalesforceCases } from 'actions/salesforce'
import { getLastUpdatedOpenCase } from 'util/salesforce'
import { useLocalization } from 'localization'

const IDVHelpStatusPage: React.FC = () => {
  const { t } = useLocalization()
  const [idvHelpSummary, setIdvHelpSummary] = useState<any>(null)

  useEffect(() => {
    getSalesforceCases().then((data) => {
      const mostRecentIDVHelp = getLastUpdatedOpenCase(data, 'idv')
      setIdvHelpSummary(mostRecentIDVHelp || null)
    })
  }, [])

  return (
    <Page sidebar={<DriveSidebar />}>
      <Helmet>
        <title>{t('dweb_dashboard_salesforce_idv_idvhelp_status_help_status')}</title>
      </Helmet>
      <CaseStatus summary={idvHelpSummary} type={'idv'} />
    </Page>
  )
}

export default IDVHelpStatusPage
